


















































































import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
import {
  BrandData,
} from 'mostra';

interface DataType {
  descriptionTexts: object;
}

// type DescriptionKind = 'twitter' | 'instagram' | 'facebook' | 'pinterest' | 'youtube';

interface DescriptionTexts {
  twitter: string[],
  instagram: string[],
  facebook: string[],
  pinterest: string[],
  youtube: string[],
}

const descriptionTexts: DescriptionTexts = {
  twitter: [
    'IDの確認方法',
    '「Twitter」を開く→自分のアイコンをタップ→「プロフィール」→名前の下の@マークに続く半角英数がユーザーID',
    '（例：@Granstra_com←この「Granstra_com」がユーザーID）',
  ],
  instagram: [
    'IDの確認方法',
    '「Instagram」を開く→「プロフィール」→「プロフィールを編集」→「ユーザーネーム」',
  ],
  facebook: [
    'ユーザーネームの確認方法',
    '「Facebook」を開く→自分のアイコンをタップ→（例：@Granstra_com←この「Granstra_com」がユーザーID）',
  ],
  pinterest: [
    'IDの確認方法',
    '「Pinterest」を開く→自分のアイコンをタップ→URL「https://www.pinterest.jp/●●●●●/boards/」の●●●●●になります',
    '（例：https://www.pinterest.jp/granstra_com/boards←この「granstra_com」がID）',
  ],
  youtube: [
    'IDの確認方法',
    '「You Tube」を開く→自分のアイコンをタップ→URL「https://www.youtube.com/channel/●●●●●」の●●●●●になります',
  ],
};

export default Vue.extend({
  name: 'GBrandSnsForm',
  props: {
    brand: {
      type: Object as PropType<BrandData>,
      default: () => ({}),
    },
  },
  data(): DataType {
    return {
      descriptionTexts: descriptionTexts,
    };
  },
});
